import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API_CONFIG } from '../config/api';

const EditAparatForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [nazivAparata, setNazivAparata] = useState('');
  const [idBroj, setIdBroj] = useState('');
  const [idUstanova, setIdUstanova] = useState('');
  const [ustanove, setUstanove] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState('');

  const token = localStorage.getItem('token');

  const fetchUstanove = async () => {
    try {
      const response = await fetch(API_CONFIG.ENDPOINTS.USTANOVE, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Greška prilikom dohvaćanja ustanova.');
      const data = await response.json();
      setUstanove(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const fetchAparat = async () => {
    try {
      const response = await fetch(`${API_CONFIG.ENDPOINTS.APARATI}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Greška prilikom dohvaćanja aparata.');
      const data = await response.json();
      setNazivAparata(data.naziv_aparata || '');
      setIdBroj(data.id_broj || '');
      setIdUstanova(String(data.id_ustanova || ''));
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setError(null);
      await Promise.all([fetchUstanove(), fetchAparat()]);
      setLoading(false);
    };
    init();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess('');

    try {
      const response = await fetch(`${API_CONFIG.ENDPOINTS.APARATI}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          naziv_aparata: nazivAparata,
          id_broj: idBroj,
          id_ustanova: idUstanova,
        }),
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.error || 'Greška prilikom uređivanja aparata.');
      }
      setSuccess('Aparat je uspješno uređen.');
      setTimeout(() => navigate('/aparati'), 800);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-[50vh] text-gray-600">Učitavanje...</div>;
  }
  if (error) {
    return (
      <div className="max-w-md mx-auto p-4">
        <div className="p-3 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">Greška: {error}</div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto">
      <div className="p-8 bg-white rounded-lg shadow-sm border border-gray-200 w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Uredi aparat</h2>
        {success && (
          <div className="p-3 mb-4 text-sm text-green-700 bg-green-100 rounded-lg">{success}</div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="nazivAparata" className="block text-sm font-medium text-gray-700">Naziv aparata</label>
            <input
              id="nazivAparata"
              type="text"
              value={nazivAparata}
              onChange={(e) => setNazivAparata(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              required
            />
          </div>
          <div>
            <label htmlFor="idBroj" className="block text-sm font-medium text-gray-700">ID broj</label>
            <input
              id="idBroj"
              type="text"
              value={idBroj}
              onChange={(e) => setIdBroj(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              required
            />
          </div>
          <div>
            <label htmlFor="idUstanova" className="block text-sm font-medium text-gray-700">Ustanova</label>
            <select
              id="idUstanova"
              value={idUstanova}
              onChange={(e) => setIdUstanova(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              required
            >
              <option value="">-- Odaberite ustanovu --</option>
              {ustanove.map((u) => (
                <option key={u.id_ustanova} value={String(u.id_ustanova)}>
                  {u.naziv_ustanove}
                </option>
              ))}
            </select>
          </div>

          <div className="flex gap-2">
            <button
              type="submit"
              className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            >
              Sačuvaj
            </button>
            <button
              type="button"
              onClick={() => navigate('/aparati')}
              className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition-colors"
            >
              Otkaži
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAparatForm;
